import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SOURCES, getSmallImageSize, getImageUrl } from 'client/utils/image-helpers';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { Image } from 'site-modules/shared/components/image/image';
import { Link } from 'site-modules/shared/components/link/link';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import './best-cars-card.scss';

export function renderSegment(segment) {
  const { title } = segment;
  const metadata = segment.getAllMetadata();
  const linkText = metadata.title;
  const linkUrl = metadata['link-url'];

  if (!linkUrl || !linkText) return null;

  return (
    <Fragment key={segment.id}>
      <span className="label d-block">{title}</span>
      <Link to={linkUrl} className="car-link d-block mb-1 heading-5-inline underline">
        {linkText}
      </Link>
    </Fragment>
  );
}

export function BestCarsCard({ content = DEFAULT_CONTENT, className = null, isLazyImage = false }) {
  const { title } = content;
  const image = content.getAllMetadata()['media-image'];
  const imageAltText = content.getAllMetadata()['media-image-alt'];
  const firstSegment = content.child('segment-1');
  const secondSegment = content.child('segment-2');
  const thirdSegment = content.child('segment-3');
  const segments = [firstSegment, secondSegment, thirdSegment];
  const shopAll = content.child('shop-all');
  const shopAllUrl = shopAll.getAllMetadata()['link-url'];
  const imageUrl = getImageUrl(image, getSmallImageSize(image), SOURCES.MEDIA);

  return (
    <div className={classnames('best-cars-card d-flex flex-column text-gray-darker', className)}>
      <Link to={shopAllUrl} rel="nofollow">
        <h3 className="card-title heading-4 mb-0">{title}</h3>
      </Link>
      <div className="best-cars-image">
        <AspectRatioContainer aspectRatio="3:2">
          <Link to={firstSegment.getAllMetadata()['link-url']}>
            <Image imageId={imageUrl} alt={imageAltText} source={SOURCES.MEDIA} lazy={isLazyImage} className="w-100" />
          </Link>
        </AspectRatioContainer>
      </div>
      <div className="top-segments">{segments.map(segment => renderSegment(segment))}</div>
      <ArrowLink to={shopAllUrl} rel="nofollow">
        {shopAll.title}
      </ArrowLink>
    </div>
  );
}

BestCarsCard.propTypes = {
  content: PropTypes.shape({}),
  className: PropTypes.string,
  isLazyImage: PropTypes.bool,
};
